// api client
import axios from 'axios'
import { client } from '../api/client'

// types
import { HomeData } from '../types/homeTypes'
import { OCP_APIM_SUBSCRIPTION_KEY, API_BASE_URL } from '../config'

/**
 * Home app data
 *
 * @returns Promise<HomeData>
 */
const fetchData = (id: number): Promise<HomeData> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(`/OnBoarding/${id}/Home`)

      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'Could not fetch data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const fetchfirsttime = (id): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `/OnBoarding/GetFirstDayStatus?essUserkey=${id}`
      )

      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'Could not fetch data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const PostfirstTime = (id): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.patch(
        `/OnBoarding/UpdateFirstDayStatus?essUserkey=${id}`
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'Could not fetch data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postlogDetails = (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(`/OnBoarding/PostAppLoginInfo`, data)
      if ((response.status = 200)) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const fetchcorporation = (EntityId, CorpId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `OnBoarding/GetCorpName?EntityId=${EntityId}&CorpId=${CorpId}`
      )
      if ((response.status = 200)) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const fetchMaintenance = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/OnBoarding/GetMaintanceDetails`,
        { headers: { 'Ocp-Apim-Subscription-Key': OCP_APIM_SUBSCRIPTION_KEY } }
      )
      if (response.status == 200) {
        resolve(response.data)
      }
    } catch (error) {
      reject(error)
    }
  })
}

const fetchCompanyName = (essUserkey) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `OnBoarding/GetCompanyName?EssUserKey=${essUserkey}`
      )
      if (response.status == 200) {
        resolve(response.data)
      }
    } catch (error) {
      reject(error)
    }
  })
}

export const homeService = {
  fetchData,
  fetchfirsttime,
  PostfirstTime,
  postlogDetails,
  fetchcorporation,
  fetchMaintenance,
  fetchCompanyName
}
